import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/data/site";
import EnquiryForm from "@/components/EnquiryForm";
import Seo from "@/components/Seo";

export default function Contact() {
  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24" data-testid="contact-page">
      <Seo
        title="PARADISIO RESORTS | Enquire — Kirra Beach &amp; Hervey Bay Accommodation"
        description="Enquire directly with owner Robert about Kirra Beach accommodation at Coolangatta and Urangan accommodation in Hervey Bay. Call 0402 423 061, email, or send the form for availability and a direct rate."
      />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="min-w-0 lg:col-span-5">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#B08A3E]">Enquiries</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#0F2A52] mt-6 leading-[1.03]">
            Talk to Robert directly
          </h1>
          <p className="text-base text-[#4A4A4A] leading-relaxed mt-8 max-w-md">
            Call, email, or send the form and Robert will reply — usually the same day — with availability and a
            direct rate for your dates.
          </p>

          <div className="mt-12 space-y-6">
            <a href={`tel:${SITE.phone}`} className="flex items-center gap-4 group" data-testid="contact-call-link">
              <span className="w-12 h-12 border border-[#0F2A52]/20 flex items-center justify-center group-hover:bg-[#0F2A52] transition-colors duration-200">
                <Phone size={18} className="text-[#0F2A52] group-hover:text-[#FCFAF6]" />
              </span>
              <span>
                <span className="block text-[11px] uppercase tracking-[0.24em] text-[#4A4A4A]">Phone</span>
                <span className="block text-lg text-[#0F2A52]">{SITE.phoneDisplay}</span>
              </span>
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-4 group" data-testid="contact-email-link">
              <span className="w-12 h-12 border border-[#0F2A52]/20 flex items-center justify-center group-hover:bg-[#0F2A52] transition-colors duration-200">
                <Mail size={18} className="text-[#0F2A52] group-hover:text-[#FCFAF6]" />
              </span>
              <span>
                <span className="block text-[11px] uppercase tracking-[0.24em] text-[#4A4A4A]">Email</span>
                <span className="block text-lg text-[#0F2A52] break-all">{SITE.email}</span>
              </span>
            </a>
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 border border-[#0F2A52]/20 flex items-center justify-center">
                <MapPin size={18} className="text-[#0F2A52]" />
              </span>
              <span>
                <span className="block text-[11px] uppercase tracking-[0.24em] text-[#4A4A4A]">Where we are</span>
                <span className="block text-lg text-[#0F2A52]">{SITE.region}</span>
              </span>
            </div>
          </div>
        </div>

        <div className="min-w-0 lg:col-span-7">
          <div className="border border-[#0F2A52]/15 p-8 md:p-12">
            <h2 className="font-display text-4xl text-[#0F2A52]">Send an enquiry</h2>
            <p className="text-sm text-[#4A4A4A] mt-3 mb-10">All fields except name and email are optional.</p>
            <EnquiryForm />
          </div>
        </div>
      </div>
    </main>
  );
}
